import cn from 'bem-cn';
import { Link } from 'react-router-dom';

import { useNavigateBack } from '../../hooks';
import { Icon, Stack } from '../UI';

import './BackButton.scss';
import { BackButtonProps } from './BackButton.types';

const b = cn('back-button');

export const BackButton = (props: BackButtonProps) => {
    const { to, className } = props;

    const handleBackButtonClick = useNavigateBack();

    if (to) {
        return (
            <Link className={b.mix(className)} to={to}>
                <Stack className={b('container')} alignItems="center" justifyContent="center">
                    <Icon className={b('icon')} name="backArrow" />
                </Stack>
            </Link>
        );
    }

    return (
        <button className={b.mix(className)} onClick={handleBackButtonClick}>
            <Stack className={b('container')} alignItems="center" justifyContent="center">
                <Icon className={b('icon')} name="backArrow" />
            </Stack>
        </button>
    );
};
